<template>
  <div class="mis-comisiones-resultado-item-card card">
    <div class="d-flex justify-content-between align-items-center gap-3 mx-2">
      <div class="d-flex flex-row gap-2 align-items-center py-2">
        <div class="comercializadora-logo-container">
          <img v-if="model?.ImagenEmpresaServicios != ''" :src="model?.ImagenEmpresaServicios!" class="comercializadora-logo" alt="" />
        </div>
        <div class="d-flex flex-column gap-1 flex-grow-1">
          <div class="nombre-oferta">{{ model?.Nombre }}</div>
          <div class="acceso-tramo-potencia">
            {{ model?.TarifaAcceso }}
            <template v-if="model?.TipoEnergia === TipoSuministroTramiteEnergiaEnum.Luz">
              · {{ model.LuzPotenciaMin }} - {{ model.LuzPotenciaMax }} kW
            </template>
          </div>
        </div>
      </div>
      <div class="d-flex flex-wrap align-items-center px-3 gap-3">
        <span class="d-inline-flex align-items-center gap-1">
          <i :class="['fa-regular fa-xl text-success', model?.TipoEnergia === TipoSuministroTramiteEnergiaEnum.Luz ? 'fa-lightbulb' : 'fa-fire', 'fa-sharp']"
            aria-hidden="true"></i>
          {{ model?.TipoEnergia === TipoSuministroTramiteEnergiaEnum.Luz ? $t("buscador-oferta-energia.luz") : $t("buscador-oferta-energia.gas") }}
        </span>
        <span v-if="model?.AplicaPersonaFisica" class="d-inline-flex align-items-center gap-1">
          <i class="fa-regular fa-xl fa-person text-success" aria-hidden="true"></i>
          {{ $t("buscador-oferta-energia.fisica") }}
        </span>
        <span v-if="model?.AplicaPersonaJuridica" class="d-inline-flex align-items-center gap-1">
          <i class="fa-regular fa-xl fa-building text-success" aria-hidden="true"></i>
          {{ $t("buscador-oferta-energia.juridica") }}
        </span>
        <span v-if="model?.LuzConAutoconsumo" class="autoconsumo-badge">
          {{ $t("buscador-oferta-energia.autoconsumo") }}
        </span>
      </div>
    </div>

    <hr class="mx-lg-4 my-0" />

    <div>
      <div class="row mx-3 mt-1 mb-1 pt-3">
        <div class="col-12 col-lg-4">
          <div class="d-flex flex-column gap-1">
            <label class="text-center">{{ $t("mis_datos.comisiones.resultados.alta_de_suministro") }}</label>
            <hr class="my-0" />
            <template v-if="comisionesPorAltaDeSuministro.length > 0">
              <div v-for="comisionOferta in comisionesPorAltaDeSuministro" :key="comisionOferta.key">
                <div class="d-flex justify-content-between align-items-center gap-2 w-100">
                  <span>{{ formatComisionTramo(comisionOferta.data) }}</span>
                  <span class="flex-shrink-0">{{ comisionOferta.data.Importe }} €</span>
                </div>
                <hr class="my-0" />
              </div>
            </template>
            <template v-else>
              <div class="text-center">{{ $t("mis_datos.comisiones.resultados.no_comisiones") }}</div>
            </template>
          </div>
        </div>
        <div class="col-12 col-lg-4">
          <div class="d-flex flex-column gap-1">
            <label class="text-center">{{ $t("mis_datos.comisiones.resultados.cambio_de_comercializadora") }}</label>
            <hr class="my-0" />
            <template v-if="comisionesPorCambioDeComercializadora.length > 0">
              <div v-for="comisionOferta in comisionesPorCambioDeComercializadora" :key="comisionOferta.key">
                <div class="d-flex justify-content-between align-items-center gap-2 w-100">
                  <span>{{ formatComisionTramo(comisionOferta.data) }}</span>
                  <span class="flex-shrink-0">{{ comisionOferta.data.Importe }} €</span>
                </div>
                <hr class="my-0" />
              </div>
            </template>
            <template v-else>
              <div class="text-center">{{ $t("mis_datos.comisiones.resultados.no_comisiones") }}</div>
            </template>
          </div>
        </div>
        <div class="col-12 col-lg-4">
          <div class="d-flex flex-column gap-1">
            <label class="text-center">{{ $t("mis_datos.comisiones.resultados.cambio_dentro_del_mismo_grupo") }}</label>
            <hr class="my-0" />
            <template v-if="comisionesPorCambioDentroDelMismoGrupo.length > 0">
              <div v-for="comisionOferta in comisionesPorCambioDentroDelMismoGrupo" :key="comisionOferta.key">
                <div class="d-flex justify-content-between align-items-center gap-2 w-100">
                  <span>{{ formatComisionTramo(comisionOferta.data) }}</span>
                  <span class="flex-shrink-0">{{ $n(comisionOferta.data.Importe) }} €</span>
                </div>
                <hr class="my-0" />
              </div>
            </template>
            <template v-else>
              <div class="text-center">{{ $t("mis_datos.comisiones.resultados.no_comisiones") }}</div>
            </template>
          </div>
        </div>
      </div>
    </div>

    <!-- Servicios -->
    <div class="mt-4">
      <DxAccordion v-model:selected-index="serviciosAccordionSelectedIndex" :collapsible="true" :multiple="false" :animation-duration="200" width="100%"
        class="mis-comisiones-accordion" item-title-template="serviciosTitle">
        <template #serviciosTitle>
          <div class="d-flex flex-wrap gap-2 align-items-center min-w-0 accordion-title">
            <span class="px-2">{{ $t("mis_datos.comisiones.resultados.servicios") }}</span>
            <span class="accordion-count">{{ model?.ComisionesServicios?.length ?? 0 }} {{ $t("mis_datos.comisiones.resultados.servicios_count") }}</span>
          </div>
        </template>
        <DxItem>
          <div class="d-flex flex-column pt-1 w-100 min-w-0">
            <div class="row gx-4 gy-2 mx-0 pt-1">
              <div v-for="(comisionServicio, sIdx) in model?.ComisionesServicios" :key="sIdx" class="col-md-12 col-lg-4">
                <div class="accordion-item h-100 p-2">
                  <div class="d-flex justify-content-between align-items-center gap-2 flex-wrap">
                    <div class="min-w-0">
                      {{ comisionServicio.Nombre }}
                    </div>
                    <div class="fw-bold">
                      {{ $n(comisionServicio.Importe) }} €
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </DxItem>
      </DxAccordion>
    </div>

    <!-- Retrocomisiones -->
    <div>
      <DxAccordion v-model:selected-index="retrocomisionesAccordionSelectedIndex" :collapsible="true" :multiple="false" :animation-duration="200" width="100%"
        class="mis-comisiones-accordion" item-title-template="retrocomisionesTitle">
        <template #retrocomisionesTitle>
          <div class="d-flex flex-wrap gap-2 align-items-center min-w-0 accordion-title">
            <span class="px-2">{{ $t("mis_datos.comisiones.resultados.retrocomisiones") }}</span>
          </div>
        </template>
        <DxItem>
          <div class="d-flex flex-column pt-1 w-100 min-w-0">
            <div class="row mx-3 mt-1 mb-1">
              <div class="col-12 col-lg-3">
                <div class="d-flex flex-column gap-1">
                  <label>{{ $t("mis_datos.comisiones.retrocomisiones.oferta") }}</label>
                  <hr class="my-0" />
                  <template v-if="retrocomisionesPorOferta.length > 0">
                    <div v-for="retrocomision in retrocomisionesPorOferta" :key="retrocomision.key">
                      <div class="d-flex justify-content-between align-items-center gap-2 w-100 flex-wrap">
                        <span>{{ retrocomision.data.Importe }}%</span>
                        <span>{{ SIMBOLO_MENOR }} {{ retrocomision.data.PeriodoHasta }} {{ $t("mis_datos.comisiones.retrocomisiones.meses") }}</span>
                        <span v-if="retrocomision.data.AplicaPersonaFisica || retrocomision.data.AplicaPersonaJuridica"
                          class="d-inline-flex align-items-center flex-shrink-0 gap-4">
                          <span v-if="retrocomision.data.AplicaPersonaFisica" class="d-inline-flex align-items-center gap-1">
                            <i class="fa-regular fa-person text-success" aria-hidden="true"></i>
                            {{ $t("buscador-oferta-energia.fisica") }}
                          </span>
                          <span v-if="retrocomision.data.AplicaPersonaJuridica" class="d-inline-flex align-items-center gap-1">
                            <i class="fa-regular fa-building text-success" aria-hidden="true"></i>
                            {{ $t("buscador-oferta-energia.juridica") }}
                          </span>
                        </span>
                      </div>
                      <hr class="my-0" />
                    </div>
                  </template>
                  <template v-else>
                    <div class="text-center">{{ $t("mis_datos.comisiones.retrocomisiones.no_comisiones") }}</div>
                  </template>
                </div>
              </div>
              <div class="col-12 col-lg-3">
                <div class="d-flex flex-column gap-1">
                  <label>{{ $t("mis_datos.comisiones.retrocomisiones.servicio") }}</label>
                  <hr class="my-0" />
                  <template v-if="retrocomisionesPorServicio.length > 0">
                    <div v-for="retrocomision in retrocomisionesPorServicio" :key="retrocomision.key">
                      <div class="d-flex justify-content-between align-items-center gap-2 w-100 flex-wrap">
                        <span>{{ retrocomision.data.Importe }}%</span>
                        <span>{{ SIMBOLO_MENOR }} {{ retrocomision.data.PeriodoHasta }} {{ $t("mis_datos.comisiones.retrocomisiones.meses") }}</span>
                        <span v-if="retrocomision.data.AplicaPersonaFisica || retrocomision.data.AplicaPersonaJuridica"
                          class="d-inline-flex align-items-center flex-shrink-0 gap-4">
                          <span v-if="retrocomision.data.AplicaPersonaFisica" class="d-inline-flex align-items-center gap-1">
                            <i class="fa-regular fa-person text-success" aria-hidden="true"></i>
                            {{ $t("buscador-oferta-energia.fisica") }}
                          </span>
                          <span v-if="retrocomision.data.AplicaPersonaJuridica" class="d-inline-flex align-items-center gap-1">
                            <i class="fa-regular fa-building text-success" aria-hidden="true"></i>
                            {{ $t("buscador-oferta-energia.juridica") }}
                          </span>
                        </span>
                      </div>
                      <hr class="my-0" />
                    </div>
                  </template>
                  <template v-else>
                    <div class="text-center">{{ $t("mis_datos.comisiones.retrocomisiones.no_comisiones") }}</div>
                  </template>
                </div>
              </div>
            </div>
          </div>
        </DxItem>
      </DxAccordion>
    </div>

    <!-- Rappels -->
    <div>
      <DxAccordion v-model:selected-index="rappelsAccordionSelectedIndex" :collapsible="true" :multiple="false" :animation-duration="200" width="100%"
        class="mis-comisiones-accordion" item-title-template="rappelsTitle">
        <template #rappelsTitle>
          <div class="d-flex flex-wrap gap-2 align-items-center min-w-0 accordion-title">
            <span class="px-2">{{ $t("mis_datos.comisiones.resultados.rappels") }}</span>
          </div>
        </template>
        <DxItem>
          <div class="d-flex flex-column pt-1 w-100 min-w-0">
            <div class="row mx-3 mt-1 mb-1 g-3">
              <div class="col-12 col-lg-3">
                <div class="d-flex flex-column gap-1">
                  <template v-if="rappels.length > 0">
                    <div v-for="rappel in rappels" :key="rappel.key">
                      <div class="d-flex justify-content-between align-items-center gap-2 w-100 flex-wrap">
                        <span>{{ rappel.data.Nombre }}</span>
                        <span>{{ formatRappelVolumen(rappel.data) }}</span>
                        <span>{{ rappel.data.Importe }} €</span>
                        <span class="d-inline-flex align-items-center flex-shrink-0 gap-4">
                          <span v-if="rappel.data.TipoSuministro === TipoSuministroTramiteEnergiaEnum.Luz" class="d-inline-flex align-items-center gap-1">
                            <i class="fa-regular fa-lightbulb text-success" aria-hidden="true"></i>
                            {{ $t("buscador-oferta-energia.luz") }}
                          </span>
                          <span v-if="rappel.data.TipoSuministro === TipoSuministroTramiteEnergiaEnum.Gas" class="d-inline-flex align-items-center gap-1">
                            <i class="fa-regular fa-fire text-success" aria-hidden="true"></i>
                            {{ $t("buscador-oferta-energia.gas") }}
                          </span>
                          <span v-if="rappel.data.TipoElemento === TipoElementoOperacionEnergiaEnum.Oferta" class="d-inline-flex align-items-center gap-1">
                            <i class="fa-regular fa-tag text-success" aria-hidden="true"></i>
                            {{ $t("mis_datos.comisiones.resultados.oferta") }}
                          </span>
                          <span v-if="rappel.data.TipoElemento === TipoElementoOperacionEnergiaEnum.Servicio" class="d-inline-flex align-items-center gap-1">
                            <i class="fa-regular fa-bars text-success" aria-hidden="true"></i>
                            {{ $t("mis_datos.comisiones.resultados.servicio") }}
                          </span>
                        </span>
                      </div>
                      <hr class="my-0" />
                    </div>
                  </template>
                  <template v-else>
                    <div class="text-center">{{ $t("mis_datos.comisiones.retrocomisiones.no_comisiones") }}</div>
                  </template>
                </div>
              </div>
            </div>
          </div>
        </DxItem>
      </DxAccordion>
    </div>
  </div>
</template>

<script setup lang="ts">
import type { ComisionOfertaEnergiaColaboradoresListItemModel, OfertaEnergiaRetribucionesColaboradoresListItemModel, RappelListItemModel } from "@api/api";
import { TipoConceptoCriterioRetrocomisionEnergiaEnum, TipoElementoOperacionEnergiaEnum, TipoSuministroTramiteEnergiaEnum, TipoTramiteComisionEnergiaEnum } from "@api/api";
import DxAccordion, { DxItem } from "devextreme-vue/accordion";
import { computed, ref } from "vue";
import uniqueId from "lodash/uniqueId";

const serviciosAccordionSelectedIndex = ref(-1);
const retrocomisionesAccordionSelectedIndex = ref(-1);
const rappelsAccordionSelectedIndex = ref(-1);

const SIMBOLO_MENOR_IGUAL = "≤";
const SIMBOLO_MAYOR_IGUAL = "≥";
const SIMBOLO_MENOR = "<";

const props = defineProps<{
  model: OfertaEnergiaRetribucionesColaboradoresListItemModel;
}>();

const comisionesPorAltaDeSuministro = computed(() =>
  (props.model?.ComisionesOferta.filter((comision) => comision.TipoTramite === TipoTramiteComisionEnergiaEnum.Alta) ?? []).map((comisionOferta) => ({
    key: uniqueId("comisionOferta-"),
    data: comisionOferta,
  })),
);

const comisionesPorCambioDeComercializadora = computed(() =>
  (props.model?.ComisionesOferta.filter((comision) => comision.TipoTramite === TipoTramiteComisionEnergiaEnum.CambioComercializadora) ?? []).map((comisionOferta) => ({
    key: uniqueId("comisionOferta-"),
    data: comisionOferta,
  })),
);

const comisionesPorCambioDentroDelMismoGrupo = computed(() =>
  (props.model?.ComisionesOferta.filter((comision) => comision.TipoTramite === TipoTramiteComisionEnergiaEnum.CambioMismoGrupo) ?? []).map((comisionOferta) => ({
    key: uniqueId("comisionOferta-"),
    data: comisionOferta,
  })),
);

const retrocomisionesPorOferta = computed(() =>
  (props.model?.Retrocomisiones.filter((retrocomision) => retrocomision.TipoConcepto === TipoConceptoCriterioRetrocomisionEnergiaEnum.Oferta) ?? []).map((retrocomision) => ({
    key: uniqueId("retrocomision-"),
    data: retrocomision,
  })),
);

const retrocomisionesPorServicio = computed(() =>
  (props.model?.Retrocomisiones.filter((retrocomision) => retrocomision.TipoConcepto === TipoConceptoCriterioRetrocomisionEnergiaEnum.Servicio) ?? []).map((retrocomision) => ({
    key: uniqueId("retrocomision-"),
    data: retrocomision,
  })),
);

const rappels = computed(() =>
  (props.model?.Rappels ?? []).map((rappel) => ({
    key: uniqueId("rappel-"),
    data: rappel,
  })),
);

function isTramoLimiteAbierto(valor: number | null | undefined): boolean {
  return valor == null || valor === 0;
}

function formatTramoRango(
  min: number | null | undefined,
  max: number | null | undefined,
  unidad: string,
): string {
  if (isTramoLimiteAbierto(min) && isTramoLimiteAbierto(max)) {
    return "";
  }
  if (isTramoLimiteAbierto(min)) {
    return `${SIMBOLO_MENOR_IGUAL} ${max} ${unidad}`;
  }
  if (isTramoLimiteAbierto(max)) {
    return `${SIMBOLO_MAYOR_IGUAL} ${min} ${unidad}`;
  }
  return `${min} - ${max} ${unidad}`;
}

function formatComisionTramo(comision: ComisionOfertaEnergiaColaboradoresListItemModel): string {
  const partes: string[] = [];

  if (comision.AplicaPotencia) {
    const tramoPotencia = formatTramoRango(comision.PotenciaMin, comision.PotenciaMax, "kW");
    if (tramoPotencia) {
      partes.push(tramoPotencia);
    }
  }

  if (comision.AplicaConsumo) {
    const tramoConsumo = formatTramoRango(comision.ConsumoMin, comision.ConsumoMax, "kWh");
    if (tramoConsumo) {
      partes.push(`[${tramoConsumo}]`);
    }
  }

  return partes.join(" ");
}

function formatRappelVolumen(rappel: RappelListItemModel): string {
  let texto = `${SIMBOLO_MAYOR_IGUAL} ${rappel.VolumenMin}`;
  if (!isTramoLimiteAbierto(rappel.PotenciaMax)) {
    texto += ` [${SIMBOLO_MENOR} ${rappel.PotenciaMax} kW]`;
  }
  return texto;
}

</script>

<style lang="scss" scoped>
.mis-comisiones-resultado-item-card {
  border-radius: var(--border-radius-xl, 16px);
  border: 1px solid var(--border-default-default);
  background: var(--background-surface-default);
  box-shadow: 0 3px 10px 0 rgba(14, 20, 26, 0.1);
  overflow: hidden;
  font-size: var(--font-size-body-sm, 12px);
}

.comercializadora-logo-container {
  width: auto;
  height: 50px;
  min-width: 150px;
  min-height: 50px;
  flex-shrink: 0;
  padding: 5px;
  display: flex;
  justify-content: center;
  align-items: center;
}

.comercializadora-logo {
  max-width: 80%;
  max-height: 100%;
  object-fit: contain;
}

.nombre-oferta {
  color: var(--text-primary-default);
  font-size: var(--font-size-heading-h5, 16px);
  font-weight: 700;
  line-height: var(--line-height-heading-h5, 14px);
}

.accordion-title {
  background: var(--background-normal-light);
  font-size: var(--font-size-body-sm, 12px);
  font-weight: 400;
  line-height: var(--line-height-body-sm, 18px);
  border-top: 1px solid var(--border-default-default);
  border-radius: var(--border-radius-none);
}

.accordion-count {
  display: flex;
  padding: var(--spacing-3xs, 2px) var(--spacing-xs, 8px);
  justify-content: center;
  align-items: center;
  gap: 10px;
  border-radius: var(--tag-radius, 6px);
  background: var(--background-secondary-light);
  color: var(--text-default-default);
  font-size: var(--font-size-body-sm, 12px);
  line-height: var(--line-height-body-sm, 18px);
}

.accordion-item {
  border: 1px solid var(--border-default-default);
  border-radius: 8px;
  padding: 5px;
}

.autoconsumo-badge {
  background: var(--background-secondary-default);
  color: var(--text-secondary-on-action);
  padding: var(--spacing-2xs, 4px) var(--spacing-xs, 8px);
  border-radius: var(--tag-radius, 6px);
}

.mis-comisiones-accordion {
  font-size: var(--font-size-body-sm, 12px);
  line-height: var(--line-height-body-sm, 18px);
}

/*
 * Ajustes en el accordion de servicios y descuentos.
 * Ordenamos caption primero y el icono después para alinear la flecha a la derecha.
 */
:deep(.mis-comisiones-accordion.dx-accordion) {
  border: none;
  background: transparent;
}

:deep(.mis-comisiones-accordion .dx-accordion-item-title-caption) {
  order: 1;
  margin-inline-end: 0;
  flex: 1 1 auto;
  min-width: 0;
}

:deep(.mis-comisiones-accordion .dx-accordion-item-title::before) {
  order: 2;
  margin-inline-end: 0;
  margin-inline-start: auto;
}
</style>
